import type { CSS } from '../../stitches.config';

export type DisplayTypes =
  | 'block'
  | 'contents'
  | 'flex'
  | 'flow-root'
  | 'grid'
  | 'hidden'
  | 'inline'
  | 'inline-block'
  | 'inline-flex'
  | 'inline-grid'
  | 'inline-table'
  | 'list-item'
  | 'table'
  | 'table-caption'
  | 'table-cell'
  | 'table-column'
  | 'table-column-group'
  | 'table-footer-group'
  | 'table-header-group'
  | 'table-row'
  | 'table-row-group';

export type DisplayProps = { display?: DisplayTypes };

export const displayCSS = (display?: DisplayTypes): CSS => {
  if (display) {
    return { display };
  }

  return {};
};
